import AccountPaymentMethodRow from './AccountPaymentMethodRow';

export default AccountPaymentMethodRow;
